<ion-header>
    <ion-toolbar
        [ngClass]="{
            'wrapper-without-height-main': !isLoginPage(),
            'wrapper-without-height-login': isLoginPage(),
        }"
        color="primary"
        style="--padding-start: 0; --padding-end: 0">
        <ion-buttons
            slot="start"
            style="--margin-inline-start: 0; margin-left: 0">
            <ion-menu-toggle>
                <ion-button data-testid="menu-toggle-button">
                    <ion-icon
                        name="menu"
                        slot="start"
                        style="color: white !important; font-size: 24px">
                    </ion-icon>
                </ion-button>
            </ion-menu-toggle>
            @if (!isRootPage()) {
                <ion-back-button
                    (click)="goToPreviousPage()"
                    [defaultHref]="'/'"
                    style="color: white !important">
                </ion-back-button>
            }
        </ion-buttons>
        @if (!isLoginPage()) {
            <ion-buttons
                slot="end"
                style="margin-right: 15px">
                @for (
                    pageConfig of appConfig().pageConfigs
                        | MenuItemsFilter: roles() : appConfig().features : configService.config();
                    track pageConfig.pageId
                ) {
                    @if (pageConfig.url) {
                        <ion-button
                            (click)="openPage(pageConfig.url)"
                            [id]="pageConfig.pageId"
                            [ngClass]="{
                                'main-title-active':
                                    mainTitleActive(pageConfig.categories) &&
                                    pageConfig?.configuration?.headerVisibility,
                                'main-title':
                                    !mainTitleActive(pageConfig.categories) &&
                                    pageConfig?.configuration?.headerVisibility,
                                'main-title-display-none': !pageConfig?.configuration?.headerVisibility,
                            }"
                            class="web">
                            @if (pageConfig.logo) {
                                <ion-icon
                                    [ngClass]="{ 'extra-right-margin': pageConfig.configuration.onlyIcon }"
                                    class="medium-icon"
                                    [name]="pageConfig.logo">
                                </ion-icon>
                            }
                            @if (!pageConfig.configuration?.onlyIcon) {
                                <span style="margin-left: 10px; margin-right: 10px">{{
                                    pageConfig.title | translate
                                }}</span>
                            }
                        </ion-button>
                    }
                    @if (
                        this.menuService.fetchSubPageConfig(pageConfig.childPageConfigs, roles())?.length > 0 &&
                        !pageConfig.url
                    ) {
                        <ion-button
                            (click)="presentPopover($event, pageConfig.childPageConfigs)"
                            [id]="pageConfig.pageId"
                            [ngClass]="{
                                'main-title-active':
                                    mainTitleActive(pageConfig.categories) &&
                                    pageConfig?.configuration?.headerVisibility,
                                'main-title':
                                    !mainTitleActive(pageConfig.categories) &&
                                    pageConfig?.configuration?.headerVisibility,
                                'main-title-display-none': !pageConfig?.configuration?.headerVisibility,
                            }"
                            class="web"
                            >{{ pageConfig.title | translate }}
                        </ion-button>
                    }
                }
                @for (generalPageConfig of appConfig().generalPageConfigs; track generalPageConfig.pageId) {
                    <ion-button
                        [ngClass]="{
                            'main-title-active':
                                mainTitleActive(generalPageConfig.categories) &&
                                generalPageConfig?.configuration?.headerVisibility,
                            'main-title':
                                !mainTitleActive(generalPageConfig.categories) &&
                                generalPageConfig?.configuration?.headerVisibility,
                            'main-title-display-none': !generalPageConfig?.configuration?.headerVisibility,
                        }"
                        [routerLink]="generalPageConfig.url"
                        class="web">
                        <span style="margin-left: 10px; margin-right: 10px">{{
                            generalPageConfig.title | translate
                        }}</span>
                    </ion-button>
                }
            </ion-buttons>
        }
        <ion-buttons
            [ngClass]="{ 'logo-button': !isLoginPage() }"
            slot="end">
            @if (showOfflineIcon()) {
                <ion-icon
                    class="medium-icon"
                    name="cloud-offline-outline">
                </ion-icon>
            }
            @if (!isLoginPage() && appConfig().theme?.hideWhiteBackgroundOfToolbarLogo && configService.logoUrl()) {
                <img
                    [routerLink]="''"
                    alt="logo"
                    class="logo-header web pointer"
                    [src]="configService.logoUrl()" />
            }

            @if (!appConfig().theme?.hideWhiteBackgroundOfToolbarLogo) {
                <ion-button
                    class="button-logo button-logo-background web"
                    fill="clear">
                    @if (!isLoginPage() && configService.logoUrl()) {
                        <img
                            [routerLink]="''"
                            alt="logo"
                            class="logo-header web pointer"
                            [src]="configService.logoUrl()" />
                    }
                </ion-button>
            }
            @if (isPatient()) {
                @for (actionButton of patientActionButtons(); track actionButton.iconName) {
                    <ion-button
                        fill="solid"
                        class="patient-action-button"
                        (click)="actionButton.onClick()">
                        <ion-icon
                            color="primary"
                            [name]="actionButton.iconName">
                        </ion-icon>
                    </ion-button>
                }
                @if (configService.config()?.configuration?.features?.profile?.enabled) {
                    <ion-button (click)="openProfile()">
                        <ion-icon name="person-circle"></ion-icon>
                    </ion-button>
                }
            }
        </ion-buttons>
    </ion-toolbar>
</ion-header>
